import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"


import { defineProps, defineComponent, reactive } from 'vue'
import useCurrentInstance from './hooks/useCurrentInstance'
const __default__ = defineComponent({
  name: 'STableColumn'
})

function setup(__props) {



const { proxy } = useCurrentInstance()
const customSlots = reactive({
  ...proxy?.$slots
})

return (_ctx: any,_cache: any) => {
  const _component_s_table_column = _resolveComponent("s-table-column")!
  const _component_el_table_column = _resolveComponent("el-table-column")!

  return (__props.column.children && __props.column.children.length)
    ? (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
        key: 0,
        key: __props.column.prop
      }, __props.column), _createSlots({
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.column.children, (_column) => {
            return (_openBlock(), _createBlock(_component_s_table_column, {
              key: _column.prop,
              column: _column
            }, _createSlots({ _: 2 }, [
              _renderList(Object.keys(_unref(customSlots)), (slot) => {
                return {
                  name: slot,
                  fn: _withCtx((scope) => [
                    _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
                  ])
                }
              })
            ]), 1032, ["column"]))
          }), 128))
        ]),
        _: 2
      }, [
        (__props.column.slotHeadName)
          ? {
              name: "header",
              fn: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, __props.column.slotHeadName, { scope: scope })
              ])
            }
          : undefined
      ]), 1040))
    : (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
        key: 1,
        key: __props.column.id
      }, __props.column), _createSlots({ _: 2 }, [
        (__props.column.slotHeadName)
          ? {
              name: "header",
              fn: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, __props.column.slotHeadName, { scope: scope })
              ])
            }
          : undefined,
        (__props.column.slotName)
          ? {
              name: "default",
              fn: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, __props.column.slotName, {
                  row: scope.row,
                  rowIndex: scope.$index
                })
              ])
            }
          : undefined
      ]), 1040))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  column: {
    type: Object,
    required: true
  }
},
  setup})